import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import { throttle, debounce } from 'underscore';
import ResizeObserverPolyfill from 'resize-observer-polyfill';




Snappy.Component.ScrollProgress= class ScrollProgress extends Snappy.BaseComponent {
    static get tagName() {
        return 'scroll-progress';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

        this.setParameters();
        this.updateBar();
        this.initResizeObserver();


    }

    initResizeObserver() {
        const RO = (typeof window.ResizeObserver === 'function') ? window.ResizeObserver : ResizeObserverPolyfill;
        const resizeDebounced = debounce(this.onResizeFinished.bind(this), 300);
        const ro = new RO((entries) => {
            for (const entry of entries) {
                resizeDebounced();
            }
        });

        ro.observe(this.mainContentNode);
    }

    setVars() {
        this.$document = $(document);
        this.mainContentNode = document.querySelector('#main-content');
        this.$thumb = this.$element.find('.js-scroll-progress-thumb');
        this.$landingPageGrid = this.$document.find('.js-landing-page-grid');
    }

    setEventListeners() {
        const throttledScrollHandler = throttle(this.scrollHandler.bind(this), 100);
        this.$window.on(
            'scroll',
            throttledScrollHandler
        );
    }

    updateBar() {
        const scrollValue = this.$window.scrollTop();
        const progress = (scrollValue / this.activeHeight).toFixed(2);
        this.$thumb.css('transform', `scaleX(${progress})`);
    }

    onResizeFinished() {
        this.setParameters();
        this.updateBar();
    }

    scrollHandler() {
        this.updateBar();
    }

    setParameters() {
        this.documentHeight = this.$document.height();
        this.activeHeight = this.getActiveHeight();
    }

    getActiveHeight() {
        if (this.$landingPageGrid.length === 1) {
            let h = this.$landingPageGrid.outerHeight();
            const $twoColSublayout = this.$landingPageGrid.prev().filter('.js-two-column-sublayout');
            if ($twoColSublayout.length) {
                h += $twoColSublayout.outerHeight();
            }
            return h;
        }
        return this.$window.height();
    }


};



// WEBPACK FOOTER //
// ./components/scroll-progress/scripts/scroll-progress.js